import BaseModelAPI from '../BaseModelAPI';

export default class ScrapExecutionList extends BaseModelAPI {

	static entity = 'scrapexecutionlist'
	static entityName = 'scrapexecution';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
